export const STORAGE_KEYS = {
  accessToken: 'anchor_access_token',
  refreshToken: 'anchor_refresh_token',
  sessionId: 'anchor_session_id',
  anchorProfile: 'anchor_profile',
  beautySettings: 'anchor_beauty_settings_v1',
} as const
